
import { AppBar, Divider, Drawer, IconButton, List, ListItem, ListItemIcon, makeStyles, Toolbar } from '@material-ui/core';
import React, { useState } from 'react';
import logo from '../images/port.svg';
import {Link,animateScroll as scroll} from "react-scroll";
import InfoTwoToneIcon from "@material-ui/icons/InfoTwoTone";
import EmojiObjectsTwoToneIcon from "@material-ui/icons/EmojiObjectsTwoTone";
import BuildTwoToneIcon from "@material-ui/icons/BuildTwoTone";
import ContactMailTwoToneIcon from "@material-ui/icons/ContactMailTwoTone";
import CancelIcon from "@material-ui/icons/Cancel"
import MenuIcon from "@material-ui/icons/Menu";




const NavBar = () => {
    const classes = useStyles();
    const[open,setOpen] = useState(false);

    const links = [
        {
            id:"about",
            text:"About me",
            icon: <InfoTwoToneIcon fontSize="large" />
        },
        {
            id:"skills",
            text:"My Coding",
            icon: <EmojiObjectsTwoToneIcon fontSize="large"
            className={classes.light}/>
        },
        {
            id:"work",
            text:"My Projects",
            icon: <BuildTwoToneIcon fontSize="large"/>
        },
        {
            id:"contact",
            text:"Get in touch",
            icon: <ContactMailTwoToneIcon fontSize="large"/>
        },
    ]

    const scrollToTop = () => {
        scroll.scrollToTop();
    }

    return (
     <>
        <AppBar position="sticky" className={classes.root}>
            <Toolbar className={classes.toolbar}>
                <img 
                src={logo} 
                className={classes.logo} 
                alt="Logo" 
                onClick={scrollToTop}
                />
                 <List className={classes.menu}>
                     {
                         links.map(({id,text},index) => (
                             <Link key={index} 
                             to={id} 
                             spy={true} 
                             activeClass="active" 
                             smooth={true} 
                             duration={1000} 
                             offset={-100}
                             
                             > {text} </Link>
                         ))
                     }
                 </List>

                 <IconButton edge="end" 
                 className={classes.menubutton}
                 onClick={() =>setOpen(!open)}
                 >
                   <MenuIcon fontsize="large"
                   
                   />
                 </IconButton>

            </Toolbar>
        </AppBar>

        <Drawer anchor="right" open={open}
        onClose={() => setOpen(false) }>
          <IconButton  onClick={() => setOpen(false)} 
          className={classes.cancelicon} >
              <CancelIcon fontSize="large"/>
          </IconButton>
          <Divider/>
          {
                         links.map(({id,text,icon},index) => (
                             <Link 
                             key={index} 
                             to={id} 
                             className={classes.sidebar}
                             spy={true} 
                             activeClass="active" 
                             smooth={true} 
                             duration={1100} 
                             offset={-100}
                             > 
                             <ListItem component="h5">
                                 <span>
                                     <ListItemIcon>
                                         {icon}
                                     </ListItemIcon> 
                                </span>{text} 
                             </ListItem>
                             
                             </Link>
                         ))
                     }

        </Drawer>
    </>
    )
}

const useStyles = makeStyles((theme) => ({ 
    root:{
        backgroundColor:"#d4d5d6",
        top:0,
        left:0,
        right:0,
        zIndex:999
    },
    toolbar:{
       display:"flex",
       justifyContent:"flex-start",
       alignItems:"center",
       
    },
    logo: {
        height:"6.5rem",
        objectFit:"contain",
        "&:hover":{
            cursor:"pointer"
        }
    },
    light:{
        color:"#ffcc00"
    },
    menu:{
        
        [theme.breakpoints.down("sm")]: {
            display:"none"
        },
        "& a":{
            color:"white",
            fontSize:"1.4rem",
            fontWeight:'bold',
            marginLeft:theme.spacing(3)
        },
        "& a:hover":{
            cursor:'pointer',
            color:'#1eba8b',
            borderBottom:"3px solid #1eba8b",
        } 
    },
    menubutton:{
        "&:hover":{
            backgroundColor:"#faf7f7"
        },
        marginRight:theme.spacing(0.2),
         display:"none",
         [theme.breakpoints.down("sm")]:{
             display:"block",
             color:"#1eba8b",
             position:"absolute",
             top:"1.5rem",
             right:10
             

         }
    },
    cancelicon:{
         color:"#1eba8b",
         position:"absolute",
         top:0,
         right:10,
    },
    sidebar:{
        
         width:"30vw",
        [theme.breakpoints.down("sm")]:{
            width:"50vw"
        },
       "& h5":{
           margin:theme.spacing(5,0,0,3),
           fontSize:"1.4rem",
           color:"#b0b5b3",
           fontWeight:"bold"
       },
       "& h5:hover":{
           color:"#1eba8b",
           cursor:"pointer"
       },
       [theme.breakpoints.down("xs")]:{
        width:"80%"
       },
       
     }


    
  }))
export default NavBar;
